import {
  createCellActions,
  createCellPlainStatuses,
} from '../builder-definition/tables';
import {
  createCellBool, createCellIconRenderer,
} from '../builder-definition/tables/plain-builders';

export default {
  headers: [
    {
      value: 'menuItemId',
      text: 'ID',
      name: 'menuItemId',
      width: '58px',
      sortable: false,
      hideable: false,
      isShown: true,
      ...createCellPlainStatuses({
        mapper: 'menuGeneral',
        statusProp: 'status',
      }),
    },
    {
      value: 'name',
      name: 'name',
      text: 'Name',
      width: '225px',
      sortable: false,
      hideable: false,
      isShown: true,
    },
    {
      value: 'icon',
      text: 'Icon',
      width: '60px',
      sortable: false,
      isShown: true,
      ...createCellIconRenderer(),
    },
    {
      value: 'parent.url',
      name: 'parent.url',
      text: 'Parent',
      width: '136px',
      sortable: false,
      hideable: false,
      isShown: true,
    },
    {
      value: 'url',
      text: 'Url',
      width: '194px',
      sortable: false,
      isShown: true,
    },
    {
      value: 'isEnabled',
      name: 'is_enabled',
      text: 'Enabled',
      width: '100px',
      sortable: false,
      isShown: true,
      ...createCellBool(),
    },
    {
      value: 'isAllowedForGuest',
      name: 'is_allowed_for_guest',
      text: 'Guest user',
      width: '100px',
      sortable: false,
      isShown: true,
      ...createCellBool(),
    },
    {
      value: 'isAllowedForAuthorized',
      name: 'is_allowed_for_authorized',
      text: 'Authorized user',
      width: '100px',
      sortable: false,
      isShown: true,
      ...createCellBool(),
    },
    {
      text: 'Status',
      value: 'status',
      isHidden: true,
    },
    {
      value: 'actions',
      text: 'Actions',
      width: '60px',
      searchable: false,
      sortable: false,
      isShown: true,
      ...createCellActions({
        actionItems: (tableElement) => {
          const defaultActions = [
            {
              text: 'Unarchive',
              value: 'restore',
              prop: 'restore',
              callBack: (item, store) => {
                store.dispatch('menuGeneral/unarchive', item.mainId);
              },
            },
            {
              text: 'Archive',
              value: 'archivable',
              prop: 'archivable',
              callBack: (item, store) => {
                store.dispatch('menuGeneral/archive', item.mainId);
              },
            },
            {
              text: 'Change position',
              value: 'changePosition',
              prop: 'changePosition',
              callBack: (item, store) => {
                store.dispatch('menuGeneral/positionModal/openPositionalModal');
              },
            },
            {
              text: 'Edit',
              value: 'editable',
              prop: 'editable',
              callBack: (item, store) => {
                store.dispatch('menuGeneral/editorDialog/openEditModal', item.menuItemId);
              },
            },
          ];
          const excluded = [];
          const filteredActions = defaultActions.filter(({ prop }) => {
            if (!prop) return true;

            return tableElement.actions[prop]
              ? tableElement.actions[prop]
              : false;
          });
          const finalActions = filteredActions.filter(({ value }) => !excluded.includes(value));

          return finalActions;
        },
      }),
    },
  ],
};
